module.exports = __webpack_public_path__ + "01_long_yellow.1cdad42d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/01_long_yellow.png
// module id = 902G
// module chunks = 0